import { StateSignals } from '@ngrx/signals';

import { NavigationPositionItem } from '../models/navigation-position-item.type';
import { NavigationProductItem } from '../models/navigation-product-item.type';
import { NavigationState } from './navigation.store';

export const navigationFeatureMethodsFactory = (store: StateSignals<NavigationState>) => ({
  search(query: string): Map<NavigationProductItem['fullName'], NavigationPositionItem[]> {
    const matchingPositionsMap = new Map<NavigationProductItem['fullName'], NavigationPositionItem[]>();

    const searchPositions = (productFullName: NavigationProductItem['fullName'], positions: NavigationPositionItem[]) => {
      for (const position of positions) {
        if (position.items) {
          searchPositions(productFullName, position.items);
        } else {
          const { description, label } = position;
          const lowerCasedQuery = query.toLowerCase();

          if (description?.toLowerCase().includes(lowerCasedQuery) || label.toLowerCase().includes(lowerCasedQuery)) {
            const matchingPositions = matchingPositionsMap.get(productFullName);
            matchingPositions ? matchingPositions.push(position) : matchingPositionsMap.set(productFullName, [position]);
          }
        }
      }
    };

    for (const product of store.products()) {
      const positions = store.positionsMap().get(product.application);
      positions && searchPositions(product.fullName, positions);
    }

    return matchingPositionsMap;
  },
});
